import { render } from "./HelpTip.vue?vue&type=template&id=3bf3558a&scoped=true"
import script from "./HelpTip.vue?vue&type=script&lang=js"
export * from "./HelpTip.vue?vue&type=script&lang=js"

import "./HelpTip.vue?vue&type=style&index=0&id=3bf3558a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf3558a"]])

export default __exports__